import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 11.289 9.596",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.289 9.596\" id=\"check\"><g transform=\"matrix(.26458 0 0 .26458 -5693.569 -500.389)\"><path d=\"m1885-8985.426 5 4.426 7.5-8.854-1.667-1.771-5.833 7.182-3.333-2.754z\" transform=\"translate(15084.866 32582.569) scale(3.41333)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol